// @generated by protoc-gen-es v1.10.0
// @generated from file fingertip/common/enum/v1/form_field_type.proto (package fingertip.common.enum.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { proto3 } from "@bufbuild/protobuf";

/**
 * @generated from enum fingertip.common.enum.v1.FormFieldType
 */
export const FormFieldType = /*@__PURE__*/ proto3.makeEnum(
  "fingertip.common.enum.v1.FormFieldType",
  [
    {no: 0, name: "FORM_FIELD_TYPE_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "FORM_FIELD_TYPE_TEXT", localName: "TEXT"},
    {no: 2, name: "FORM_FIELD_TYPE_HEADING", localName: "HEADING"},
    {no: 3, name: "FORM_FIELD_TYPE_TEXTAREA", localName: "TEXTAREA"},
    {no: 4, name: "FORM_FIELD_TYPE_NUMBER", localName: "NUMBER"},
    {no: 5, name: "FORM_FIELD_TYPE_RADIO", localName: "RADIO"},
    {no: 6, name: "FORM_FIELD_TYPE_CHECKBOX", localName: "CHECKBOX"},
    {no: 7, name: "FORM_FIELD_TYPE_SELECT", localName: "SELECT"},
    {no: 8, name: "FORM_FIELD_TYPE_EMAIL", localName: "EMAIL"},
    {no: 9, name: "FORM_FIELD_TYPE_PHONE", localName: "PHONE"},
    {no: 10, name: "FORM_FIELD_TYPE_DATE", localName: "DATE"},
    {no: 11, name: "FORM_FIELD_TYPE_TIME", localName: "TIME"},
    {no: 12, name: "FORM_FIELD_TYPE_FILE", localName: "FILE"},
    {no: 13, name: "FORM_FIELD_TYPE_SIGNATURE", localName: "SIGNATURE"},
    {no: 14, name: "FORM_FIELD_TYPE_NAME", localName: "NAME"},
  ],
);

